<template>
  <div class="product__feature">
    <el-row :gutter="30">
      <el-col :sm="18">
        <h3>{{ heading }}</h3>
        <div v-html="body"></div>
        <h4 v-if="benefit">{{ benefit }}</h4>
      </el-col>
      <el-col :sm="6">
        <media-image :image="mediaImage"/>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import MediaImage from '@/components/media/MediaImage';

  export default {
    name: 'ProductFeature',
    props: {
      heading: {
        type: String
      },
      body: {
        type: String
      },
      benefit: {
        type: String
      },
      mediaImage: {
        type: Object
      }
    },
    components: {
      MediaImage
    }
  }
</script>

<style lang="scss" scoped>
  h4 {
    color: #ED1C2E;
    font-style: italic;
    font-weight: bold;
  }

  .product__feature {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .feature__image {
    position: relative;

    a {
      display: block;
    }

    span {
      z-index: 2;
      display: block;
      top: 0;
      left: 0;
      position: absolute;
      width: 30px;
      height: 30px;
      background-color: red;
      text-align: center;
      line-height: 30px;

      i {
        color: white;
      }
    }

    img {
      width: 100%;
      height: auto;
    }
  }
</style>
